export const StageColors = [
    { background: "#2A848E", border: "#96C7CC"},
    { background: "#ffffff", border: "#ededed"},
    { background: "#DB7838", border: "#E99B69"},
    { background: "#CECCCA", border: "#DAD9D6"},
    { background: "#FED425", border: "#FCE47E"}
]